import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { addDays } from 'date-fns';
import { UserPen, Trash2, Send } from 'lucide-react';
import { Actions } from '../../store/actions/organisationActions';

import { TableRow, TableCell } from '../ui/table';

const UsersListRow = ({ userDetails, toggleModal, reinviteUserBtn, adminUser, canManage }) => {
  const userStatus = _.capitalize(_.lowerCase(userDetails?.status.replace('_', ' ')));

  return (
    <TableRow className='hover:bg-muted/50 text-base' id='users-list-row'>
      <TableCell className='font-medium text-left'>
        {userDetails?.name} {userDetails?.surname}
      </TableCell>
      <TableCell>{userDetails?.email}</TableCell>
      {adminUser && <TableCell>{userStatus}</TableCell>}
      {canManage && (
        <TableCell className='flex flex-row items-center justify-center gap-4'>
          <button
            title='Edit User Permissions'
            id='edit-user-permissions-button'
            onClick={() => toggleModal(true, userDetails, 'manageUser')}
            className='cursor-pointer text-accent hover:text-secondary duration-300'>
            <UserPen size={20} strokeWidth={1.5} />
          </button>
          <button
            title='Disable User'
            id='disable-user-button'
            onClick={() => toggleModal(true, userDetails, 'disableUser')}
            className='cursor-pointer text-accent hover:text-destructive duration-300'>
            <Trash2 size={20} strokeWidth={1.5} />
          </button>
          {reinviteUserBtn && (
            <button
              title='Reinvite User'
              id='reinvite-user-button'
              onClick={() => toggleModal(true, userDetails, 'reinviteUser')}
              className='cursor-pointer text-accent hover:text-primary duration-300'>
              <Send size={20} strokeWidth={1.5} />
            </button>
          )}
        </TableCell>
      )}
    </TableRow>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { userDetails, adminUser } = ownProps;
  const today = new Date().toISOString();
  const expiryDate = userDetails?.createdDate && addDays(new Date(userDetails?.createdDate), 7)?.toISOString();
  const isExpired = today > expiryDate;

  // Show reinvite button just for admin users and if user is expired and status is FORCE_CHANGE_PASSWORD.
  const reinviteUserBtn = adminUser && userDetails?.status === 'FORCE_CHANGE_PASSWORD' && isExpired;
  return {
    reinviteUserBtn,
    canManage: !!state?.organisation?.permissions?.organisation?.manage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleModal: (status, item, action) => dispatch(Actions.toggleModal(status, item, action)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersListRow);
